import { useEffect, useRef } from "react";
import { baseUrl } from "../../../utils/apiData";

const AminitiesCard = ({data, setHeightList, h}) => {
    const cardRef = useRef(null);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
          if (cardRef.current) {
            const height = cardRef?.current?.getBoundingClientRect()?.height;
            if (setHeightList) {
              setHeightList((prev) => {
                return [...prev, height];
              });
            }
          }
        }, 1000);
        return () => {
          clearTimeout(timeOutId);
        };
      }, []);

    return(
         <div className="ameniti_slide"  style={{ minHeight: `${h}px` }}   ref={cardRef}>
                                  <div className="img_wrap">
                                    <img
                                      src={`${baseUrl}/${data?.image}`}
                                      alt="Amnities"
                                    />
                                  </div>
                                  <div className="info">
                                    <h6>{data?.title}</h6>
                                    <p className="gold">{data?.description}</p>
                                  </div>
                                </div>
    )
}

export default AminitiesCard;